import Splide from '@splidejs/splide';

export const isMobile = () => window.innerWidth <= 767;

export const initArrows = (slider) => {
  const arrows = Array.from(slider.querySelectorAll('.splide__arrow'));
  if (arrows?.length > 0) {
    const imgHeight = slider.querySelector('.is-visible img')?.offsetHeight;
    if (imgHeight) {
      arrows.forEach((arrow) => {
        arrow.style.top = imgHeight / 2 + 'px';
      });
    }
  }
};

/**
 * @param {HTMLElement} slider — root element with class .slider.splide
 * @returns {Splide}
 */
export const initImageInspirationSlider = (slider) => {
  let resizeObserver = null;

  const splide = new Splide(slider, {
    type: 'loop',
    start: 0,
    focus: 'center',
    autoWidth: true,
    gap: '6px',
    arrows: false,
    updateOnMove: true,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        gap: '8px',
        arrows: true,
      },
    },
  });

  splide.on('ready', () => {
    const imgElement = slider.querySelector('.is-visible img');
    if (!imgElement) return;
    resizeObserver = new ResizeObserver(() => {
      if (!isMobile()) initArrows(slider);
    });
    resizeObserver.observe(imgElement);
  });

  splide.on('destroy', () => {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  });

  splide.mount();
  return splide;
};
